import SessionEventProto from "../session-event-proto"

export default class SessionEventNew extends SessionEventProto {

    private header : {
        event       : any
        isBulkUpdate: boolean
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.method     = sessionEvent.method
        this.header     = {
            event       : sessionEvent.event,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false
        if (!!gd.session.events) gd.session.events.addOne(this.data)

        // console.log("SessionEventNew process", this);

        gd.modelBus.newUpdate('event', this.method, this.header.event.id, this.data, this.header)
    }
}